module.exports = function() {
  return new Worker(__webpack_public_path__ + "dd22815fa7ef6caa1972.worker.js");
};